import { captureException, SeverityLevel, withScope } from '@sentry/react';
import {
  extractErrorDiagnostics,
  isResponseHeaders,
} from '~/helpers/errorDiagnostics.helper';

interface Tags {
  contractId?: number;
  clientId?: number;
  referrerUrl?: string;
  organizationNumber?: string;
  pn?: string;
  applicationUuid?: string;
  public?: boolean;
  lookupOrgNr?: string;
  companyIds?: string;
  loginConnectionName?: string;
}

export function logToSentry(
  error: any,
  category: string,
  tags?: Tags,
  level: SeverityLevel = 'error'
) {
  let extraMessage = 'undefined';

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    extraMessage = JSON.stringify(error.response.data);
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
    extraMessage = JSON.stringify(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error: ', error);
    console.log('Error message: ', error.message);
  }

  const responseHeaders = error?.response?.headers;
  const diagnostics = isResponseHeaders(responseHeaders)
    ? extractErrorDiagnostics(responseHeaders)
    : undefined;

  withScope((scope) => {
    scope
      .setTransactionName(category)
      .setFingerprint([String(error.message), ...(category ? [category] : [])])
      .setExtra('ExtraMessage', extraMessage)
      .setLevel(level)
      .setTags({
        ...tags,
        identifier: category,
        ...(diagnostics && {
          'qred.error_id': diagnostics.errorId,
          'qred.trace_id': diagnostics.traceId,
          'qred.request_id': diagnostics.requestId,
        }),
      });

    captureException(error);
  });
}
